// extracted by mini-css-extract-plugin
export var section = "styles-module--section--e21f1";
export var showLogo = "styles-module--showLogo--f984e";
export var wrapper = "styles-module--wrapper--ca70e";